export default {"src":"/_next/static/media/walletIcon.11e576be.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};